export default "__VITE_ASSET__CNr0z1Gf__"